import { render, staticRenderFns } from "./BaseAbout.vue?vue&type=template&id=0faf73ba&scoped=true&"
import script from "./BaseAbout.vue?vue&type=script&lang=js&"
export * from "./BaseAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf73ba",
  null
  
)

export default component.exports